module.exports = __webpack_public_path__ + "img/child.229c6ac0.svg";